"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyPlanPopover = void 0;
/* eslint-disable import/prefer-default-export */
var react_1 = __importStar(require("react"));
var dayjs_1 = __importDefault(require("dayjs"));
var react_router_dom_1 = require("react-router-dom");
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var ui_1 = require("@21st-night/ui");
var icons_1 = require("@21st-night/icons");
var core_2 = require("@21st-night/core");
var StudyPlanItemDraggable_1 = __importDefault(require("../StudyPlanItemDraggable"));
var StudyPlanSubItem_1 = __importDefault(require("../StudyPlanSubItem"));
var StudyPlanItemFormContainer_1 = __importDefault(require("../StudyPlanItemFormContainer"));
var Button_1 = __importDefault(require("../../Button"));
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            overflow: 'visible',
        },
        count: {
            minWidth: 24,
        },
        buttonLabel: {
            fontWeight: 'bold',
            textTransform: 'none',
        },
        buttonStartIcon: {
            '& > *:first-child': {
                fontSize: '13px',
            },
        },
        paper: {
            width: 500 + theme.spacing(4),
            overflow: 'visible',
            boxSizing: 'border-box',
            position: 'relative',
            padding: theme.spacing(3, 2, 3, 2),
            zIndex: 'auto',
            boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.1),0px 5px 8px 0px rgba(0, 0, 0, 0.07),0px 1px 14px 0px rgba(0, 0, 0, 0.06)',
            marginTop: 11,
        },
        arrow: {
            position: 'absolute',
            top: -32,
            right: 14,
            width: 32,
            height: 32,
            overflow: 'hidden',
            boxShadow: '0 16px 10px -17px rgba(0, 0, 0, 0.5)',
            '&::after': {
                content: '""',
                position: 'absolute',
                borderTopLeftRadius: 2,
                width: 16,
                height: 16,
                backgroundColor: '#FAFAFA',
                transform: 'rotate(45deg)',
                top: 24,
                left: 8,
                boxShadow: '-1px -1px 10px -5px rgba(0, 0, 0, 0.5)',
            },
        },
        dateSelect: {
            marginBottom: theme.spacing(2),
        },
        content: {
            maxHeight: 500,
            overflowY: 'scroll',
        },
    });
});
var StudyPlanPopover = function () {
    var classes = useStyles();
    var button = react_1.useRef(null);
    var user = core_2.useUser();
    var _a = __read(react_1.useState(false), 2), open = _a[0], setOpen = _a[1];
    var _b = __read(react_1.useState(new Date()), 2), date = _b[0], setDate = _b[1];
    var _c = __read(react_1.useState([]), 2), addItemForms = _c[0], setAddItemForms = _c[1];
    var _d = __read(react_1.useState([]), 2), subitemForms = _d[0], setSubItemForms = _d[1];
    var _e = __read(react_1.useState([]), 2), editForms = _e[0], setEditForms = _e[1];
    var _f = core_2.useUserStudyPlan(), days = _f.days, toggleItemDone = _f.toggleItemDone, hasPlan = _f.hasPlan, items = _f.items, addItem = _f.addItem, moveItem = _f.moveItem, deleteItem = _f.deleteItem, updateItem = _f.updateItem;
    var day = Object.values(days).find(function (day) {
        return dayjs_1.default(day.date).isSame(date, 'date');
    }) || {
        date: date,
        items: [],
        id: 'new-day',
    };
    var todaysTasks = day
        ? day.items.filter(function (itemId) { return !!items[itemId]; }).map(function (itemId) { return items[itemId]; })
        : [];
    function previousDay() {
        setDate(dayjs_1.default(date).subtract(1, 'day').toDate());
    }
    function nextDay() {
        setDate(dayjs_1.default(date).add(1, 'day').toDate());
    }
    var toggleAddItemForm = react_1.useCallback(function (dayId) {
        setAddItemForms(function (value) {
            var newValue = __spreadArray([], __read(value));
            if (value.includes(dayId)) {
                newValue = value.filter(function (id) { return id !== dayId; });
            }
            else {
                newValue.push(dayId);
            }
            return newValue;
        });
    }, []);
    var toggleSubItemForm = react_1.useCallback(function (event, itemId) {
        event.stopPropagation();
        setSubItemForms(function (value) {
            var newValue = __spreadArray([], __read(value));
            if (value.includes(itemId)) {
                newValue = value.filter(function (id) { return id !== itemId; });
            }
            else {
                newValue.push(itemId);
            }
            return newValue;
        });
    }, []);
    var toggleEditItemForm = react_1.useCallback(function (event, itemId) {
        event.stopPropagation();
        setEditForms(function (value) {
            var newValue = __spreadArray([], __read(value));
            if (value.includes(itemId)) {
                newValue = value.filter(function (id) { return id !== itemId; });
            }
            else {
                newValue.push(itemId);
            }
            return newValue;
        });
    }, []);
    var handleAddSubItem = react_1.useCallback(function (data) {
        addItem(data);
        setSubItemForms(function (value) { return value.filter(function (id) { return id !== data.parent; }); });
    }, [addItem]);
    var handleAddItem = react_1.useCallback(function (data) {
        addItem(data);
        toggleAddItemForm(data.day);
    }, [addItem, toggleAddItemForm]);
    var handleDeleteItem = react_1.useCallback(function (event, item) {
        event.stopPropagation();
        deleteItem(item);
    }, [deleteItem]);
    var handleUpdateSubItem = react_1.useCallback(function (itemId, title) {
        updateItem(itemId, { title: title });
        setEditForms(function (value) { return value.filter(function (id) { return id !== itemId; }); });
    }, [updateItem]);
    var getitems = react_1.useCallback(function (itemIds) {
        // return Object.values(items).filter(({ id }) => itemIds.includes(id));
        var filtereditems = [];
        itemIds.forEach(function (itemId) {
            var item = items[itemId];
            if (item) {
                filtereditems.push(item);
            }
        });
        return filtereditems;
    }, [items]);
    var renderItemChildren = react_1.useCallback(function (item, day) {
        var children = getitems(item.subItems || []).map(function (subitem) {
            return !editForms.includes(subitem.id) ? (react_1.default.createElement(StudyPlanSubItem_1.default, { background: "paper", key: subitem.id, title: subitem.title, done: subitem.done, onClickEdit: function (event) {
                    return toggleEditItemForm(event, subitem.id);
                }, onClickDelete: function (event) { return handleDeleteItem(event, subitem); }, onClick: function () { return toggleItemDone(subitem); } })) : (react_1.default.createElement(StudyPlanItemFormContainer_1.default, { key: subitem.id, placeholder: "SubItem", initialValue: subitem.title, onClickCancel: function (event) {
                    toggleEditItemForm(event, subitem.id);
                }, onSubmit: function (title) { return handleUpdateSubItem(subitem.id, title); } }));
        });
        if (subitemForms.includes(item.id)) {
            children.push(react_1.default.createElement(StudyPlanItemFormContainer_1.default, { key: item.id + "-subitem-form", placeholder: "New subitem", onClickCancel: function (event) {
                    toggleSubItemForm(event, item.id);
                }, onSubmit: function (title) {
                    return handleAddSubItem({
                        title: title,
                        type: 'subitem',
                        parent: item.id,
                        day: day.id,
                        date: day.date,
                    });
                } }));
        }
        return children;
    }, [
        editForms,
        getitems,
        handleAddSubItem,
        handleDeleteItem,
        handleUpdateSubItem,
        subitemForms,
        toggleEditItemForm,
        toggleSubItemForm,
        toggleItemDone,
    ]);
    return (react_1.default.createElement("div", { ref: button },
        react_1.default.createElement(Button_1.default, { variant: "outlined", startIcon: react_1.default.createElement(core_1.Chip, { size: "small", label: todaysTasks.filter(function (task) { return !task.done; }).length, className: classes.count }), classes: { startIcon: classes.buttonStartIcon }, onClick: function () { return setOpen(true); } },
            react_1.default.createElement("span", { className: classes.buttonLabel }, "Tasks")),
        react_1.default.createElement(core_1.Popover, { classes: { root: classes.root, paper: classes.paper }, anchorEl: button.current, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'right',
            }, open: open, onClose: function () { return setOpen(false); } },
            hasPlan && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ui_1.Spaced, { centered: true, className: classes.dateSelect },
                    react_1.default.createElement(ui_1.IconButton, { onClick: previousDay },
                        react_1.default.createElement(icons_1.ChevronLeft, null)),
                    react_1.default.createElement(core_1.Typography, { variant: "h6", color: "textPrimary" },
                        react_1.default.createElement(ui_1.DatePicker, { value: date, onChange: function (value) { return setDate(value); }, inputFormat: dayjs_1.default().isSame(date, 'day') ? '[Today]' : 'D MMMM, YYYY' })),
                    react_1.default.createElement(ui_1.IconButton, { onClick: nextDay },
                        react_1.default.createElement(icons_1.ChevronRight, null))),
                react_1.default.createElement("div", { className: classes.content },
                    react_1.default.createElement(react_beautiful_dnd_1.DragDropContext, { onDragEnd: function (_a) {
                            var draggableId = _a.draggableId, source = _a.source, destination = _a.destination;
                            if (destination) {
                                moveItem(draggableId, {
                                    id: source.droppableId,
                                    index: source.index,
                                    type: 'day',
                                }, {
                                    id: destination.droppableId,
                                    index: destination.index,
                                    type: 'day',
                                });
                            }
                        } },
                        react_1.default.createElement(react_beautiful_dnd_1.Droppable, { droppableId: day.id }, function (provided, droppableState) { return (react_1.default.createElement("div", { ref: provided.innerRef },
                            getitems(day.items).map(function (item, index) {
                                return !editForms.includes(item.id) ? (react_1.default.createElement(StudyPlanItemDraggable_1.default, { background: "paper", key: item.id, index: index, id: item.id, isDragging: droppableState.isUsingPlaceholder ||
                                        droppableState.isDraggingOver, title: item.title, done: item.done, onClickDelete: function (event) {
                                        return handleDeleteItem(event, item);
                                    }, onClickEdit: function (event) {
                                        return toggleEditItemForm(event, item.id);
                                    }, onClick: function () { return toggleItemDone(item); }, onClickAddSubItem: function (event) {
                                        return toggleSubItemForm(event, item.id);
                                    } }, renderItemChildren(item, day))) : (react_1.default.createElement(StudyPlanItemFormContainer_1.default, { key: item.id, placeholder: "Item", initialValue: item.title, onClickCancel: function (event) {
                                        toggleEditItemForm(event, item.id);
                                    }, onSubmit: function (title) {
                                        return handleUpdateSubItem(item.id, title);
                                    } }, renderItemChildren(item, day)));
                            }),
                            day.items.length === 0 && (react_1.default.createElement(ui_1.ListItem, null,
                                react_1.default.createElement(ui_1.ListItemText, { disableTypography: true },
                                    react_1.default.createElement(core_1.Typography, { color: "textSecondary" }, "No tasks")))),
                            provided.placeholder,
                            react_1.default.createElement("div", null,
                                !addItemForms.includes(day.id) && (react_1.default.createElement(Button_1.default, { style: { marginLeft: 24 }, size: "small", variant: "text", onClick: function () { return toggleAddItemForm(day.id); } }, "+ Add a task")),
                                addItemForms.includes(day.id) && (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement(ui_1.Divider, null),
                                    react_1.default.createElement(StudyPlanItemFormContainer_1.default, { key: day.id + "-item-form", placeholder: "New item", onClickCancel: function () {
                                            toggleAddItemForm(day.id);
                                        }, onSubmit: function (title) {
                                            return handleAddItem({
                                                title: title,
                                                type: 'item',
                                                day: day.id,
                                                date: day.date,
                                            });
                                        } })))))); }))),
                react_1.default.createElement(ui_1.Spaced, { centered: true },
                    react_1.default.createElement(Button_1.default, { size: "small", color: "default", to: "/study-plan", component: react_router_dom_1.Link }, "Open study plan")))),
            !hasPlan && (react_1.default.createElement("div", null,
                react_1.default.createElement(core_1.Typography, { color: "textSecondary", style: {
                        maxWidth: 500,
                        textAlign: 'center',
                        marginBottom: 16,
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    } },
                    "Studying is more effective with a study plan! Let's get you a personalized",
                    user.onboarding &&
                        ['GMAT', 'GRE', 'MCAT', 'LSAT'].includes(user.onboarding.variant)
                        ? " " + user.onboarding.variant + " study plan. Would you rather"
                        : ' study plan.'),
                user.onboarding &&
                    ['GMAT', 'GRE', 'MCAT', 'LSAT'].includes(user.onboarding.variant) ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Button_1.default, { fullWidth: true, variant: "outlined", component: react_router_dom_1.Link, to: "/create-study-plan/custom", style: { marginBottom: 8 } }, "Create a study plan from scratch"),
                    react_1.default.createElement(Button_1.default, { fullWidth: true, variant: "outlined", component: react_router_dom_1.Link, to: "/create-study-plan/template" }, "Adapt one of our study plans"))) : (react_1.default.createElement(Button_1.default, { fullWidth: true, variant: "outlined", component: react_router_dom_1.Link, to: "/create-study-plan/custom" }, "Create a study plan")))),
            react_1.default.createElement("div", { className: classes.arrow }))));
};
exports.StudyPlanPopover = StudyPlanPopover;
//# sourceMappingURL=StudyPlanPopover.js.map